@if (parentSite) {
    <div>
        @if (!editMode) {
            <div>
                @if (!hasReportingParcel) {
                    <label>
                        This site ({{ parentSite.name }}) does not have a reporting parcel set.
                    </label>
                }
                @if (isAnotherParcelReportingForParentSite) {
                    <label>
                        <a href="#/parcel/{{parentSite.reportingParcelId}}">{{ parentSite.reportingParcelAcctNum }}</a>
                        is the reporting parcel for this site ({{ parentSite.name }}).
                    </label>
                }
                @if (isReportingParcelForParentSite) {
                    <label>
                        This parcel reports assets for its site ({{ parentSite.name }}).
                    </label>
                }
            </div>
        }
        @if (editMode && !isAnotherParcelReportingForParentSite && !isPartOfAMasterSite) {
            <div>
                <label for="reportingParcelForParentSite">
                    @if (editMode) {
                        <input id="reportingParcelForParentSite"
                               type="checkbox"
                               [(ngModel)]="isReportingParcelForParentSite"/>
                    } This parcel reports assets for its site ({{ parentSite.name }})
                </label>
            </div>
        }
        @if (editMode && isAnotherParcelReportingForParentSite && !isPartOfAMasterSite) {
            <div>
                <label for="reportingParcelForParentSite">
                    @if (editMode) {
                        <input id="reportingParcelForParentSite"
                               type="checkbox"
                               [(ngModel)]="isReportingParcelForParentSite"/>
                    } Make this parcel report assets for its site ({{ parentSite.name }}) - currently
                    <a href="#/parcel/{{parentSite.reportingParcelId}}">{{ parentSite.reportingParcelAcctNum }}</a> is
                    the reporting parcel.
                </label>
            </div>
        }
        @if (editMode && isPartOfAMasterSite) {
            <div>
                <label>The site of this parcel is linked to another site, and the reporting parcel comes from the master
                    site. It can't be changed here.</label>
            </div>
        }
        @if (showSiteList) {
            <div>
                <h4>Sites reported by this parcel:</h4>
                <ws-ag-grid-angular [gridOptions]="gridOptions"
                                    (gridReady)="onAgGridReady($event)">
                </ws-ag-grid-angular>
            </div>
        }
    </div>
}
